import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/site-template'

const NAME_PREFIX = 'SITE_TEMPLATE';

const DEFAULT_SIZE = 12

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

export const RECEIVE_COMPANY_DETAIL = `${NAME_PREFIX}_RECEIVE_COMPANY_DETAIL`

export const RECEIVE_PRODUCT_DETAIL = `${NAME_PREFIX}_RECEIVE_PRODUCT_DETAIL`

export const RECEIVE_TEMPLATE_AREA_LIST = `${NAME_PREFIX}_RECEIVE_TEMPLATE_AREA_LIST`

export const RECEIVE_TEMPLATE_AREA_FIRST_GROUP_LIST = `${NAME_PREFIX}_RECEIVE_TEMPLATE_AREA_FIRST_GROUP_LIST`

export const RECEIVE_TEMPLATE_AREA_SECOND_GROUP_LIST = `${NAME_PREFIX}_RECEIVE_TEMPLATE_AREA_SECOND_GROUP_LIST`

function trimForm(formData) {
    const newFormData = {};
    Object.keys(formData).forEach(key=>{
        const value = formData[key];
        if (typeof(value) === 'string') {
            newFormData[key] = value.trim();
        } else {
            newFormData[key] = value;
        }
    })
    newFormData.indexField = ['title', 'keywords', 'defaultLanguage', 'serialNum', 'refer'].map(key=>formData[key]).join('_');
    return newFormData;
}
//action
function getData(params, dispatch, form) {
    return http.post(`${API_PREFIX}/list?${qs.stringify(params)}`, form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query);
    keys.forEach(key=>{
        if (key === 'templateAreaFirstName' && query[key] === 'null') {
            form.filters.push({
                "field": key,
                "operator": "isnull",
                "value": query[key]
            })
        } else if (query[key]) {
            form.filters.push({
                "field": key,
                "operator": filterList.find(item=>item.value === key).operator,
                "value": query[key]
            })
        }
    })
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {siteTemplate: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        const form = getFormData(query, filterList);
        getData(data, dispatch, form)
    };
}

export function add(formData) {
    return (dispatch, getState) => {
        return http.post(`${API_PREFIX}/add`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update(formData) {
    return (dispatch, getState) => {
        console.info(formData);
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function showUpdateModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id})
            })
    }
}

export function getProductDetail() {
    return (dispatch,getState) => {
        const {siteTemplate: {query}} = getState()
        return http.get(`${API_PREFIX}/product-status?companyType=${query.companyType}`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_PRODUCT_DETAIL,
                    data: (data.data || []).reduce((previous, current) => {
                        previous[current[0]] = current[1];
                        previous['全部'] = previous['全部'] + current[1]; 
                        return previous;
                    }, {'全部': 0})
                })
            })
    }
}

export function getCompanyDetail() {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/company-status`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_COMPANY_DETAIL,
                    data: (data.data || []).reduce((previous, current) => {
                        previous[current[0]] = current[1];
                        previous['全部'] = previous['全部'] + current[1]; 
                        return previous;
                    }, {'全部': 0})
                })
                dispatch(getProductDetail());
            })
    }
}
export function getTemplateAreaList() {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/template-area-list`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_TEMPLATE_AREA_LIST,
                    data: (data.data || []).map(item => {
                        return {
                            ...item,
                            label: `${item.parentName ? `${item.parentName}-` : ''}${item.name}`,
                            value: item.id
                        }
                    })
                })
            })
    }
}

export function getFirstGroupList() {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/template-area-first-group`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_TEMPLATE_AREA_FIRST_GROUP_LIST,
                    data: data.data || []
                })
            })
    }
}

export function getSecondGroupList(firstName) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/template-area-second-group/${firstName}`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_TEMPLATE_AREA_SECOND_GROUP_LIST,
                    data: data.data || []
                })
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        update: false,
        id: null
    },
    detail: {},
    filterList: [
        
            {"name": "公司类型", "componentType": "Text", "data": [{"name":"森动","value":"森动"},{"name":"建站盒子","value":"建站盒子"},{"name":"原创","value":"原创"},{"name":"其他","value":"其他"}], "isShow": false, "value": "companyType", "operator": "eq"},
        
            {"name": "产品类型", "componentType": "Select", "data": [{"name":"展示","value":"展示"},{"name":"电商","value":"电商"}], "isShow": false, "value": "productType", "operator": "eq"},
        
            {"name": "关键词", "componentType": "Text", "data": [], "isShow": false, "value": "keywords", "operator": "contains"},
        
            {"name": "编号", "componentType": "Text", "data": [], "isShow": false, "value": "serial_num", "operator": "contains"},
        
            {"name": "预览链接", "componentType": "Text", "data": [], "isShow": false, "value": "preview_url", "operator": "contains"},
        
            {"name": "pc端预览图", "componentType": "Text", "data": [], "isShow": false, "value": "pc_img_url", "operator": "contains"},
        
            {"name": "移动端预览图", "componentType": "Text", "data": [], "isShow": false, "value": "m_img_url", "operator": "contains"},
        
            {"name": "二维码", "componentType": "Text", "data": [], "isShow": false, "value": "qrcode_url", "operator": "contains"},

            {"name": "模糊查询", "componentType": "Text", "data": [], "isShow": true, "value": "indexField", "operator": "contains", "hideCancelBtn": true},

            {"name": "一级分类", "componentType": "Text", "data": [], "isShow": false, "value": "templateAreaFirstName", "operator": "eq", "hideCancelBtn": true},

            {"name": "一级分类", "componentType": "Text", "data": [], "isShow": false, "value": "templateAreaSecondName", "operator": "eq", "hideCancelBtn": true},
        
    ],
    query: {
        companyType: '',
        productType: '',
        templateAreaFirstName: '',
        templateAreaSecondName: ''
    },
    companyTypeDetail: {

    },
    productTypeDetail: {

    },
    templateAreas: [],
    firstGroups: [],
    secondGroups: []
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: value}, page: {index: 0, size: DEFAULT_SIZE}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    },
    [RECEIVE_COMPANY_DETAIL]: (state,{data}) => {
        return {...state, companyTypeDetail: {...data}}
    },
    [RECEIVE_PRODUCT_DETAIL]: (state,{data}) => {
        return {...state, productTypeDetail: {...data}}
    },
    [RECEIVE_TEMPLATE_AREA_LIST]: (state,{data}) => {
        return {...state, templateAreas: data}
    },
    [RECEIVE_TEMPLATE_AREA_FIRST_GROUP_LIST]: (state,{data}) => {
        return {...state, firstGroups: data}
    },
    [RECEIVE_TEMPLATE_AREA_SECOND_GROUP_LIST]: (state,{data}) => {
        return {...state, secondGroups: data}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/site_template/reducers/list.js